import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import FileInput from '../../../common/forms/input/FileInput';
import Select from '../../../common/forms/select/Select';
import {
  DEPOSIT_MIGRATION_BANK,
  DEPOSIT_MIGRATION_MAX_FILE_SIZE,
} from '../../../../config/constants';
import { enumToSelectOptions } from '../../../../utils/enum';
import { isRequired } from '../../../../utils/validators';

const DepositMigrationForm = ({ handleSubmit, onSubmit, saving }) => (
  <Form onSubmit={handleSubmit(onSubmit)}>
    <FormGroup row>
      <FormItem label="Entidad bancaria" required>
        <Field
          name="bank"
          component={Select}
          options={enumToSelectOptions(DEPOSIT_MIGRATION_BANK)}
          placeholder="Entidad bancaria"
          validate={[isRequired]}
          isDisabled={saving}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Estado de cuenta (.xlsx)" required>
        <Field
          name="file"
          component={FileInput}
          accept=".xlsx"
          validate={[isRequired]}
          maxFileSize={DEPOSIT_MIGRATION_MAX_FILE_SIZE}
          disabled={saving}
        />
      </FormItem>
    </FormGroup>

    <FormFooter
      saveButtonText={saving ? 'Procesando...' : 'Procesar archivo'}
      saveButtonIcon="fa fa-upload"
      saveButtonDisabled={saving}
    />
  </Form>
);

DepositMigrationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

DepositMigrationForm.defaultProps = {
  saving: false,
};

const mapStateToProps = ({ SalesUnit }) => ({
  saving: !SalesUnit.DepositMigration.getIn(['current', 'activity']).isEmpty(),
});

const formComponent = reduxForm({
  form: 'DepositMigrationForm',
})(DepositMigrationForm);

export default connect(mapStateToProps)(formComponent);
